// Shows the sticky buy bar once the main buy button has scrolled above the viewport,
// and tucks it away while the footer is on screen so the footer is never covered.
if (!customElements.get('pgp-sticky-buy-bar')) {
  customElements.define(
    'pgp-sticky-buy-bar',
    class PgpStickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        this.button = this.querySelector('button');
        if (!this.target || !('IntersectionObserver' in window)) return;

        this.pastButton = false;
        this.atFooter = false;

        this.observer = new IntersectionObserver(([entry]) => {
          this.pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.update();
        });
        this.observer.observe(this.target);

        const footer = document.querySelector('footer.footer');
        if (footer) {
          this.footerObserver = new IntersectionObserver(([entry]) => {
            this.atFooter = entry.isIntersecting;
            this.update();
          });
          this.footerObserver.observe(footer);
        }
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.footerObserver?.disconnect();
      }

      update() {
        // Mirror the main button so a sold-out or unavailable variant stays disabled here too.
        if (this.pastButton) {
          this.button.disabled = this.target.disabled;
          const label = this.target.querySelector('span')?.textContent.trim();
          if (label) this.button.textContent = label;
        }
        this.classList.toggle('is-visible', this.pastButton);
        this.classList.toggle('is-at-footer', this.atFooter);
        this.inert = !this.pastButton || this.atFooter;
      }
    }
  );
}
